/**
 * @classdesc 地理编码接口
 * @alias G.service.IGeocodeService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 * @param [opts.token] {String} 口令
 * @param [opts.authUrl] {String} 认证服务地址
 * @param [opts.clientId] {String} 客户端id
 * @param [opts.clientSecret] {String} 客户端密钥
 */
class IGeocodeService {
    constructor(opts) {}
    /**
     * 获取数据库资源地名
     * @param opts
     * @param opts.keyWord {String}
     * @param [opts.pageSize] {Integer} 默认10
     * @param [opts.pageIndex] {Integer} 默认1
     */
    getAddressByKeyword(opts){}

    /**
     * 获取数据库资源地名
     * @param opts
     * @param opts.location {Array} [117,37]
     * @param [opts.spatialReference] {integer} 默认4326
     * @param [opts.radius] {number} 缓冲距离，默认1000
     */
    getAddressByLocation(opts){}
}
module.exports = IGeocodeService;